// extracted by mini-css-extract-plugin
export default {"required":"attachmentButton_required__O3W0-"};